import { VALIDATE_SPACE_NAMES } from "./apiRoutes";
import { getDataINSTANCE } from "./controller";

export const validateSpaceName = async (type,name, workspaceId = null) => {
        const encodedName = encodeURIComponent(name);
      const data = await getDataINSTANCE(`${VALIDATE_SPACE_NAMES}?type=${type}&name=${encodedName}${workspaceId ? `&workspaceId=${workspaceId}` : ""}`,"Failed to validate name");
      return data.isAvailable;
  };